"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../utils");
/**
 * Split a list item at the start of the current range.
 */


function splitListItem(opts, editor) {
  var value = editor.value;
  var currentItem = utils_1.getCurrentItem(opts)(value);

  if (!currentItem) {
    return editor;
  } // tslint:disable-next-line:no-any


  return editor.splitDescendantsByKey(currentItem.key, value.selection.start.key, value.selection.start.offset);
}

exports.default = splitListItem;